// Objectif protéique — suggestion ajustable. Repères par phase : health-guidelines.ts.
import { round } from './statistics';

// Bornes du réglage g/kg (garde-fous UI + calcul). Max 3.1 = plafond ISSN en sèche.
export const PROTEIN_PER_KG = { min: 1.2, max: 3.1, default: 1.8 } as const;

// Objectif protéique quotidien (g) = poids × g/kg (borné à [min, max]).
export function suggestProteinTarget(
  weightKg: number,
  gPerKg: number = PROTEIN_PER_KG.default,
): number {
  if (weightKg <= 0) return NaN;
  const clamped = Math.min(PROTEIN_PER_KG.max, Math.max(PROTEIN_PER_KG.min, gPerKg));
  return round(weightKg * clamped);
}
